import { IHttpApi } from '@cian/http-api';

import {
  TCianApiSiteV1GetQuickLinksResponse,
  fetchCianApiSiteV1GetQuickLinks,
} from 'shared/repositories/monolith-python/cian-api/site/v1/get-quick-links';
import { extractUndefined } from 'shared/utils/extractUndefined';

import type { IQuickLinks } from '../common/state';
import { EOfficeType, IJsonQuery } from '../json_query';

type GetQuickLinksOptions = {
  httpApi: IHttpApi;
  jsonQuery: IJsonQuery;
  subdomain: string;
};

export const getQuickLinks = ({ httpApi, jsonQuery, subdomain }: GetQuickLinksOptions): Promise<IQuickLinks | null> => {
  const isOffice = jsonQuery.office_type && jsonQuery.office_type.value[0] === EOfficeType.Office;
  const isCoworking = jsonQuery.coworking_offer_type && jsonQuery.coworking_offer_type.value.length > 0;

  if (isOffice && isCoworking) {
    return Promise.resolve(null);
  }

  return fetchCianApiSiteV1GetQuickLinks<TCianApiSiteV1GetQuickLinksResponse, TCianApiSiteV1GetQuickLinksResponse>({
    httpApi,
    parameters: {
      jsonQuery,
    },
    config: {
      subdomain,
    },
  })
    .then(({ response, statusCode }) => {
      if (statusCode === 200) {
        return extractUndefined(response.data.quickLinks);
      }

      return null;
    })
    .catch(() => {
      return null;
    });
};
